import { db } from "./firebase";

export const fetchTemplates = async () => {
  const templatesCollection = db.collection("templates");
  const snapshot = await templatesCollection.get();
  return snapshot.docs.map(doc => ({
    ...doc.data(),
    id: doc.id
  }));
};
